import type { SchemaField } from '@cli-types/core-engine/schema.js'
import { quotePropertyName } from '@cli-utils/text.js'
import { getFieldType } from './get-field-type.js'
export function getReadFieldType(field: SchemaField): string {
  if (field.type === 'select') return 'SelectOptionValue[]'
  if (field.type === 'group' && field.fields && field.fields.length > 0) {
    const groupType = field.fields
      .map(
        (nestedField) => `${quotePropertyName(nestedField.name)}?: ${getReadFieldType(nestedField)}`
      )
      .join('; ')
    return `{ ${groupType} }`
  }
  if (field.type === 'list' && field.fields && field.fields.length > 0) {
    const nestedType = field.fields
      .flatMap((nestedField) => {
        const fields = [`${quotePropertyName(nestedField.name)}?: ${getReadFieldType(nestedField)}`]
        if (nestedField.hasIcon) {
          fields.push(`${quotePropertyName(`${nestedField.name}Icon`)}?: string`)
        }
        return fields
      })
      .join('; ')
    return `Array<{ ${nestedType} }>`
  }
  return getFieldType(field, 'output')
}
